/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
import { Col, Row } from 'antd';
import { QuestionComponentProps } from '../../type';
import './styles.scss';
import { HeaderCommon, QuestionNumber, QuestionText } from '../RenderCommon';

const TickTF = ({ questionData, questionIndex, isCombineChild }: QuestionComponentProps) => {
  // const optionType = questionData.optionType.toUpperCase();
  const renderAnswers = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <QuestionNumber isCombineChild={isCombineChild} questionIndex={questionIndex} />
        {Array.isArray(questionData.answers) &&
          questionData.answers.map((item: any, index: number) => (
            <Row key={index} gutter={24} align='middle' className='tw-mb-2'>
              <Col span={8}>{item.imageUrl && <img src={item.imageUrl} style={{ maxHeight: 100, maxWidth: 400 }} />}</Col>
              <Col span={14}>{item.question && <div dangerouslySetInnerHTML={{ __html: item.question }} />}</Col>
              <Col span={2}>
                <span className='square_box' />
              </Col>
            </Row>
          ))}
      </div>
    );
  };
  return (
    <div className='tick_tf_print' style={{ marginLeft: isCombineChild ? 5 : 0 }}>
      <HeaderCommon key={questionData.id} questionData={questionData} questionIndex={questionIndex} isCombineChild={isCombineChild} />
      <QuestionText key={questionIndex} questionText={questionData.questionText} />
      {renderAnswers()}
    </div>
  );
};

export default TickTF;
